<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.mode === modes.TwelveMonHrsWorked
    ? data.sysText.caseLeaveInfo_calcTwelveMonHrsWorkedTitle
    : data.mode === modes.AvgWeeklyHrs
    ? data.sysText.caseLeaveInfo_calcAvgWeeklyHoursTitle
    : data.mode === modes.AvgWorkdays
    ? data.sysText.caseLeaveInfo_calcAvgWorkdaysTitle
    : data.sysText.caseLeaveInfo_calcAllTitle }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close()" [attr.aria-label]="(cantCalc || (!data.dialog.hasWorkSchedules && !data.dialog.hasWorkHours)) ? data.sysText.close : data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  @if (cantCalc || (!data.dialog.hasWorkSchedules && !data.dialog.hasWorkHours)) {
    @if (cantCalc) {
      <p class="body2">{{ data.sysText.caseLeaveInfo_calcMissingDetailsMessage }}</p>
      @for(missingDetail of missingDetails; track missingDetail) {
        <p class="body2">
          <span class="bullet-space">&bull;</span>{{ missingDetail }}
        </p>
      }
    }
    @if (!data.dialog.hasWorkSchedules && !data.dialog.hasWorkHours) {
      <p class="body2">{{ data.sysText.caseLeaveInfo_noSchedulesOrHours }}</p>
    }
  } @else {
    @if (calcDetails != null) {
      @for(calcDetail of calcDetails; track calcDetail) {
        <p class="body2 calc-detail">{{calcDetail}}</p>
      }
      <p class="body2">{{data.sysText.caseLeaveInfo_calcConfMessage2}}</p>
    } @else {
      <p class="body2">{{ CalcMessage }}</p>
    }
    @if (data.dialog.showSourceOption && calcDetails === null) {
      <div class="form">
        <form [formGroup]="form">
          <app-select-field
            [control]="form.controls.source"
            [label]="data.sysText.caseLeaveInfo_sourceOptionLabel"
            [options]="sourceOptions"
            [icon]="'move_to_inbox'"
            [shouldCapitalize]="false">
          </app-select-field>
        </form>
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      [mat-dialog-close]="false"
      color="accent"
      [disabled]="isSubmitting">
      {{ (cantCalc || (!data.dialog.hasWorkSchedules && !data.dialog.hasWorkHours)) ? data.sysText.close : data.sysText.cancel }}
    </button>
  }
  @if (!(cantCalc || (!data.dialog.hasWorkSchedules && !data.dialog.hasWorkHours))) {
    <!-- one button for both steps (calculate, then update), so focus stays on it when the step changes. it keeps focus while busy:
    showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && submit(calcDetails !== null)">
      {{ calcDetails === null ? data.sysText.calculate : data.sysText.update }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  }
</mat-dialog-actions>
